export const EMPTY_REFERENCE_FORM = {
  title_ar: "",
  title_en: "",
  description_ar: "",
  description_en: "",
};
